import React, { useState } from "react";
import Alert from "@amzn/meridian/esm/components/alert";
import Box from "@amzn/meridian/esm/components/box";
import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import Theme from "@amzn/meridian/esm/components/theme/theme";
import star from "../images/star.svg";
import AlertModal, { ALERT_VARIANT } from "./alertModal/AlertModal";
import { THEME_COLOR } from "../styles/colors";

const AimsException = () => {
  const [isModalOpen, setIsModalOpen] = useState(true);

  return (
    <Column spacing="none" spacingInset="none">
      <AlertModal variant={ALERT_VARIANT.SERVER_NOT_RESPONDING} isOpen={isModalOpen} />

      <Column height="40px" />
      <Column height="100px">
        <Row spacing="none" spacingInset="none">
          <Theme tokens={{ boxBorderColorOutline: THEME_COLOR.WHITE }}>
            <Box type="outline" spacingInset="none" width="68px" height="20px" />
          </Theme>
          <Box type="outline" spacingInset="none" width="226px" height="100px">
            <Row spacing="none" spacingInset="none">
              <Row spacing="none" spacingInset="none" width="16px" />
              <Column spacing="none" spacingInset="none" width="24px" height="100px">
                <Column spacing="none" spacingInset="none" height="16px" />
                <img src={star} alt="star" />
              </Column>
              <Row spacing="none" spacingInset="none" width="20px" />
              <Column spacing="none" spacingInset="none" width="133px" height="100px">
                <Column spacing="none" spacingInset="none" height="17px" />
                <Text type="h50" alignment="start">
                  Summarize meeting
                </Text>
                <Column spacing="none" spacingInset="none" height="16px" />
                <Alert type="warning" size="small">
                  Not available
                </Alert>
              </Column>
            </Row>
          </Box>
        </Row>
      </Column>
    </Column>
  );
};

export default AimsException;
